const FALLBACK_OWNER_ICON = "/images/fallback-avatar.webp";

export function getOwnerIconSrc(ownerIcon?: string | null): string {
  if (!ownerIcon?.trim()) {
    return FALLBACK_OWNER_ICON;
  }

  if (ownerIcon.startsWith("/images/owners/")) {
    return ownerIcon;
  }

  try {
    const fileName = ownerIcon.split("/").pop()?.split("?")[0]?.trim();

    if (fileName) {
      return `/images/owners/${fileName}`;
    }
  } catch {
    return FALLBACK_OWNER_ICON;
  }

  return FALLBACK_OWNER_ICON;
}